<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Manajemen Konsultan' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div
            class="d-flex align-center justify-space-between font-weight-bold font-size-20 mt-3 mb-7"
        >
            <div>Manajemen Konsultan</div>
            <div class="d-flex">
                <v-btn
                    depressed
                    color="#fff"
                    class="mr-3"
                    style="margin-top: 2px"
                    @click="getConsultantByStatus()"
                >
                    <v-icon class="mr-2" small>mdi-refresh</v-icon>
                    Refresh
                </v-btn>

                <v-select
                    v-model="mapel_id"
                    dense
                    label="Mata Pelajaran"
                    :items="mapelList"
                    outlined
                    item-text="nama"
                    hide-details
                    item-value="id"
                    style="width: 200px"
                    clearable
                    placeholder="Pilih Mata Pelajaran"
                    @change="getConsultantByStatus()"
                >
                </v-select>
            </div>
        </div>

        <consultant-management-statistic
            v-if="!loading && data_per_status"
            :data="data_per_status"
        />

        <loading-stat v-else class="mb-1" />

        <consultant-management-chart
            v-if="!loading && data_per_mapel && data_per_status"
            :data-per-mapel="data_per_mapel"
            :data-per-status="data_per_status"
        />

        <loading-chart v-else class="mb-5" />

        <consultant-management-table v-if="data" :data-status="data" />
    </div>
</template>

<script>
import ConsultantManagementTable from "./components/ConsultantManagementTable.vue";
import ConsultantManagementStatistic from "./components/ConsultantManagementStatistic.vue";
import ConsultantManagementChart from "./components/ConsultantManagementChart.vue";
import LoadingStat from "./components/LoadingStat.vue";
import LoadingChart from "./components/LoadingChart.vue";
import firebase from "firebase";

export default {
    name: "consultant-management",

    components: {
        ConsultantManagementTable,
        ConsultantManagementStatistic,
        ConsultantManagementChart,
        LoadingStat,
        LoadingChart,
    },

    data() {
        return {
            loading: false,
            data_per_status: null,
            data_per_mapel: null,
            data: null,
            mapel_id: null,
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    mounted() {
        this.getConsultantByStatus();
    },

    methods: {
        async getConsultantByStatus() {
            this.loading = true;
            this.data_per_status = null;
            this.data_per_mapel = null;
            await this.delay(500);

            try {
                let docRef = firebase
                    .firestore()
                    .collection("consultant_status");

                if (this.mapel_id) {
                    docRef = docRef.where(
                        "mapel",
                        "array-contains",
                        this.mapel_id,
                    );
                }

                // Mengambil data sekali saja tanpa listener
                const snapshot = await docRef.get();
                let row = [];

                snapshot.forEach((doc) => {
                    row.push(doc.data());
                });

                this.data = row;
                this.groupingByStatus();
                this.groupingByMapel();
            } catch (error) {
                console.log("Fetch Messages Error:", error);
            } finally {
                this.loading = false;
            }
        },

        groupingByStatus() {
            this.data_per_status = {
                total: this.data.length,
                active: this.data.filter((e) => e.is_active === 1).length || 0,
                non_active:
                    this.data.filter((e) => e.is_active === 0).length || 0,
                online:
                    this.data.filter((e) => e.status === "online").length || 0,
                offline:
                    this.data.filter((e) => e.status === "offline").length || 0,
                busy: this.data.filter((e) => e.status === "busy").length || 0,
            };
        },

        groupingByMapel() {
            const result = this.data.reduce((acc, item) => {
                if (!item.mapel || !Array.isArray(item.mapel)) return acc;

                item.mapel.forEach((mapel_id) => {
                    const found = acc.find((m) => m.mapel_id === mapel_id);
                    const mapelData = this.mapelList
                        ? this.mapelList.find((e) => e.id === mapel_id)
                        : {};

                    const mapelName =
                        mapelData && mapelData.nama
                            ? mapelData.nama
                            : "Mapel Lainnya";

                    if (found) {
                        found.total += 1;
                        found.mapel_name = mapelName;
                    } else {
                        acc.push({
                            mapel_id,
                            total: 1,
                            mapel_name: mapelName,
                        });
                    }
                });

                return acc;
            }, []);

            this.data_per_mapel = this.mapel_id
                ? result.filter((e) => e.mapel_id === this.mapel_id)
                : result;
        },
        delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },
    },
};
</script>



// WEBPACK FOOTER //
// ConsultantManagement.vue?e635cda4